module.exports = __webpack_public_path__ + "img/no-notes.ea7a5601.svg";